import { useEffect, useRef, useState } from 'react';

const contactItems = [
  {
    label: 'Address',
    icon: 'ri-map-pin-2-line',
    lines: ['45 Evropa str.', 'City Yambol', 'Zip 8600', 'Country Bulgaria'],
  },
  {
    label: 'Email',
    icon: 'ri-mail-line',
    lines: ['information@eloparood.com'],
  },
  {
    label: 'Number',
    icon: 'ri-phone-line',
    lines: ['+1 6416375110'],
  },
];

export default function ContactSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" className="py-24 md:py-32" style={{ background: 'linear-gradient(135deg, #0a0f1e 0%, #0d1b2a 60%, #0f2744 100%)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div
          ref={ref}
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(32px)',
            transition: 'opacity 0.8s ease, transform 0.8s ease',
          }}
        >
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 border-b border-white/10 pb-12">
            <div>
              <span className="text-xs font-semibold tracking-[3px] uppercase text-sky-400 mb-3 block">
                Get In Touch
              </span>
              <h2
                className="text-4xl md:text-5xl font-extrabold text-white leading-tight"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                Contact
                <br />
                <span className="text-white/40 font-light">ELOPAR OOD</span>
              </h2>
            </div>
            <p className="text-white/40 text-base leading-relaxed max-w-sm md:text-right">
              Reach out to us for inquiries about our iOS products or to learn more about what we do.
            </p>
          </div>

          {/* Contact Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {contactItems.map((item, i) => (
              <div
                key={item.label}
                className="bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/8 transition-colors duration-300"
                style={{
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'translateY(0)' : 'translateY(24px)',
                  transition: `opacity 0.7s ease ${0.1 + i * 0.12}s, transform 0.7s ease ${0.1 + i * 0.12}s`,
                }}
              >
                {/* Label + Icon */}
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-500/20 border border-sky-500/30">
                    <i className={`${item.icon} text-sky-400 text-lg`} />
                  </div>
                  <span className="text-xs font-bold tracking-[2px] uppercase text-sky-400">
                    {item.label}
                  </span>
                </div>

                {/* Lines */}
                <div className="space-y-1.5">
                  {item.lines.map((line) => (
                    <p key={line} className="text-white/80 text-base font-medium leading-relaxed">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <span
              className="text-white font-bold text-lg tracking-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              ELOPAR OOD
            </span>
            <p className="text-white/30 text-sm text-center sm:text-right">
              &copy; {new Date().getFullYear()} ELOPAR OOD. All rights reserved. iOS App Development.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
